'use client';

import Dropdown from '@/components/dropdown/dropdown.component';
import { LIST_STATES_UF as BASE_LIST_STATES_UF } from '@/helpers/constants';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import './result-dropdown.scss';

export default function ResultDropdownUF({ vehicleType }: { vehicleType: string }) {
    const router = useRouter();
    const searchParams = useSearchParams();

    const [isLoading, setIsLoading] = useState(false);

    const LIST_STATES_UF = [
        { value: 'BR', label: 'Média nacional' },
        ...BASE_LIST_STATES_UF,
    ];

    useEffect(() => {
        setIsLoading(false);
    }, [searchParams]);

    const handleUFSelect = (option: any) => {
        if (!option?.value) return;

        const selectedUF = option.value.toLowerCase();
        const currentUF = searchParams.get('uf')?.toLowerCase();
        setIsLoading(true)

        if (selectedUF === currentUF || (selectedUF === 'br' && !currentUF)) {
            setIsLoading(false);
            return;
        }

        const params = new URLSearchParams(searchParams.toString());

        if (selectedUF === 'br') {
            params.delete('uf');
            const query = params.toString();
            router.replace(query ? `?${query}` : window.location.pathname, { scroll: false });
        } else {
            params.set('uf', selectedUF);
            router.replace(`?${params.toString()}`, { scroll: false });
        }
    };

    const defaultOption =
        LIST_STATES_UF.find(
            (option) => option.value.toLowerCase() === searchParams.get('uf')?.toLowerCase()
        ) || { value: 'BR', label: 'Média nacional' };

    return (
        <div className="result-dropdown-uf" data-testid="result-dropdown-uf">
            <p className="result-dropdown-uf__text">
                Preço Webmotors conforme média nacional. Altere para ver em seu estado.
            </p>
            <div className='result-dropdown-uf__select-group'>
                <Dropdown
                    id="result-dropdown-uf__select"
                    placeholder="Busca"
                    placeholderTitle="Selecione o estado"
                    initialOptions={LIST_STATES_UF}
                    onSelect={handleUFSelect}
                    isDisabled={false}
                    selectValue={defaultOption}
                    isLoading={isLoading}
                    isUFselect={true}
                />
            </div>
        </div>
    );
}